export default __webpack_public_path__ + "static/media/icon-server.60f6f694.svg";